import { Grid, Stack, Typography } from "@mui/material";
import { useStoreContext } from "../..";
import { useEffect } from "react";
import dayjs from "dayjs";
import { observer } from "mobx-react";
import { Treatment } from "../../models/Treatments";
import EditButton from "../EditButton";

const AntibioticDayList = observer(
  ({ onClick }: { onClick: (day: Treatment) => void }) => {
    const { treatmentStore, drugStore, indicationStore } = useStoreContext();

    useEffect(() => {
      if (!treatmentStore.treatments) {
        treatmentStore.getTreatments();
      }
    }, [treatmentStore.treatments]);

    useEffect(() => {
      if (!drugStore.drugs) {
        drugStore.getDrugs();
      }
    }, [drugStore.drugs]);

    useEffect(() => {
      if (!indicationStore.indications) {
        indicationStore.getIndications();
      }
    }, [indicationStore.indications]);

    const treatments = treatmentStore.treatments;

    if (
      !treatments ||
      !drugStore.mappedListDrugs ||
      !indicationStore.mappedIndications
    ) {
      return null;
    }

    return (
      <>
        {treatments.map((item, index) => (
          <Grid
            container
            key={`${item.startDate}-${index}`}
            p={2}
            sx={{
              borderBottom: "1px solid lightgrey",
              backgroundColor: item.endDate ? "white" : "#ffcccc",
            }}
            spacing={2}
          >
            <Grid item xs={12} sm={3}>
              <Stack direction="column">
                <Typography sx={{ marginBottom: 1 }}>
                  <b>Från: </b>
                  {dayjs(item.startDate).format("YYYY-MM-DD")}
                </Typography>
                <EditButton onClick={() => onClick(item as Treatment)} />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Stack direction="column">
                <Typography sx={{ marginTop: 1 }}>
                  <b>Till: </b>
                  {item.endDate ? dayjs(item.endDate).format("YYYY-MM-DD") : ""}
                </Typography>
                <Typography>
                  <b>Substansnamn: </b>
                  {drugStore.mappedListDrugs?.get(item.drugId) || item.drugId}
                </Typography>
                <Typography>
                  <b>Indikation: </b>
                  {indicationStore.mappedIndications?.get(item.indicationId) ||
                    item.indicationId}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        ))}
      </>
    );
  }
);

export default AntibioticDayList;
